<section class="message my-5 text-center">
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="container">
    <div class="my-5" [ngClass]="{ 'p-4': !isMobile, 'p-2': isMobile }">
      <img
        src="
    assets/images/icons/verify-popup.svg"
        alt=""
        class="img-fluid"
      />
      <h6 class="title fw-bold my-3">Verify your account</h6>
      <p class="text-dark">You can’t view this project because your account is not verified.</p>

      <div class="row buttons mt-5">
        <div class="col-lg-6" [ngClass]="{ 'mb-2': !isMobile, ' mb-3': isMobile }">
          <button class="btn btn-outline-default w-100" type="button" (click)="closeModal()">
            Stay on page
          </button>
        </div>

        <div class="col-lg-6" [ngClass]="{ 'mb-2': !isMobile, ' mb-3': isMobile }">
          <button class="btn btn-default w-100" type="button" (click)="doActionTrue()">
            Verify account
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
